import type { ApolloClient } from '@apollo/client';
import { ApolloProvider } from '@apollo/client/react';
import type { ReactNode } from 'react';
import { Toaster } from 'sonner';
import { ConsentBanner } from '@/components/consent-banner';

type ProvidersProps = { client: ApolloClient; children: ReactNode };

export function Providers({ client, children }: ProvidersProps) {
  return (
    <ApolloProvider client={client}>
      {children}
      <ConsentBanner />
      <Toaster theme="dark" position="bottom-right" className="z-toast" />
    </ApolloProvider>
  );
}
